import BaseLayout from "layouts/base-layout";
import React, { useEffect } from "react";
import RenderModules from "helpers/render-modules";
import { SEO } from "../components/SEO";
import { MetaPixel, TiktokPixel, Klaviyo, AdsenseVerification } from "../utils/pixel";

const Page = ({ pageContext, location }) => {
  const { meta, content, settings, googleReviews } = pageContext;

  return (
    <BaseLayout
      meta={meta}
      data={{ ...settings, googleReviews }}
      location={location}
    >
      {content.modules && <RenderModules modules={content.modules} />}
    </BaseLayout>
  );
};

export const Head = ({ pageContext }) => {
  const {
    meta,
    handle: { current },
    title,
  } = pageContext;

  return (
    <>
      <MetaPixel />
      <TiktokPixel />
      <AdsenseVerification />
      <Klaviyo />
      <SEO
        meta={meta}
        path={null}
        handle={current}
        additionalTitle={title}
        additionalDescription={title}
      />
    </>
  );
};

export default Page;
